export interface SelfContactInfo {
  email?: string;
  phone?: string;
}

const normalizeEmail = (value: string): string => value.trim().toLowerCase();

// Cognito stores E.164 ("+1XXXXXXXXXX") while the form collects 10 digits, so
// compare on the last 10 digits of each.
const lastTenDigits = (value: string): string =>
  value.replace(/\D/g, "").slice(-10);

export const matchesSelfEmail = (
  contactEmail: string,
  self: SelfContactInfo
): boolean => {
  if (!contactEmail.trim() || !self.email?.trim()) return false;
  return normalizeEmail(contactEmail) === normalizeEmail(self.email);
};

export const matchesSelfPhone = (
  contactPhone: string,
  self: SelfContactInfo
): boolean => {
  const contactDigits = lastTenDigits(contactPhone);
  return (
    contactDigits.length === 10 &&
    contactDigits === lastTenDigits(self.phone ?? "")
  );
};
